module.exports = __webpack_public_path__ + "static/media/frame-expand.50f7ac12.svg";